import React from 'react';
import { t } from 'i18next';

import { PageContentS, PageHeaderS, PageWrapS, Paragraph, SectionHeaderS } from './legalPagesS';

import { getNumbersToReplace } from './agbComponent';

import withGATracker from '../../../utils/enhancers/withGATracker';

const DataProtection = () => (
  <PageWrapS>
    <PageContentS>

      <PageHeaderS>{t('dataProtection.pageTitle')}</PageHeaderS>

      <SectionHeaderS> {t('dataProtection.firstSection.header')}</SectionHeaderS>
      <Paragraph>{t('dataProtection.firstSection.text')}</Paragraph>

      <SectionHeaderS>{t('dataProtection.secondSection.header')}</SectionHeaderS>
      <Paragraph
        dangerouslySetInnerHTML={{
          __html: t('dataProtection.secondSection.text', {
            ...getNumbersToReplace(3, 2),
            redPoint: '<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #d90e4b" ></span>',
            interpolation: { escapeValue: false }
          } )
        }} />

      <SectionHeaderS> {t('dataProtection.thirdSection.header')}</SectionHeaderS>
      <Paragraph
        dangerouslySetInnerHTML={{
          __html: t('dataProtection.thirdSection.text', {
            ...getNumbersToReplace(3, 2),
            redPoint: '<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #d90e4b" ></span>',
            interpolation: { escapeValue: false }
          } )
        }} />

      <SectionHeaderS> {t('dataProtection.forthSection.header')}</SectionHeaderS>
      <Paragraph>{t('dataProtection.forthSection.text')}</Paragraph>

      <SectionHeaderS> {t('dataProtection.fifthSection.header')}</SectionHeaderS>
      <Paragraph>{t('dataProtection.fifthSection.text')}</Paragraph>

      <SectionHeaderS> {t('dataProtection.sixthSection.header')}</SectionHeaderS>
      <Paragraph>{t('dataProtection.fifthSection.text')}</Paragraph>

      <SectionHeaderS> {t('dataProtection.seventhSection.header')}</SectionHeaderS>
      <Paragraph>{t('dataProtection.seventhSection.text')}</Paragraph>

      <SectionHeaderS> {t('dataProtection.eighthSection.header')}</SectionHeaderS>
      <Paragraph>{t('dataProtection.eighthSection.text')}</Paragraph>

      <SectionHeaderS> {t('dataProtection.ninethSection.header')}</SectionHeaderS>
      <Paragraph>{t('dataProtection.ninethSection.text')}</Paragraph>

    </PageContentS>
  </PageWrapS>
);

export default withGATracker(DataProtection);
